// eslint-disable-next-line import/prefer-default-export
function getPlacement(align, position) {
  return align === 'center' ? position : `${position}-${align}`;
}

export { getPlacement as g };
//# sourceMappingURL=utils-BDd8EZN8.js.map
